export default "__VITE_ASSET__tifikX2E__"